import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ItIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_495_2817)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M17.3569 10.2858V13.5001C17.3569 13.6706 17.2891 13.8341 17.1686 13.9547C17.048 14.0752 16.8845 14.143 16.714 14.143H1.28544C1.11494 14.143 0.951426 14.0752 0.830867 13.9547C0.710307 13.8341 0.642578 13.6706 0.642578 13.5001V3.21439C0.642578 3.04389 0.710307 2.88037 0.830867 2.75983C0.951426 2.63926 1.11494 2.57153 1.28544 2.57153H3.85686",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.71443 14.1428L6.42871 17.3571",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.2852 14.1428L11.5709 17.3571",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M5.14258 17.3572H12.8569",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M7.07129 7.07139H10.9284V9.64282L14.7856 7.07139H17.357V0.642822H7.07129V7.07139Z",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_495_2817",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
